// extracted by mini-css-extract-plugin
export default {"link":"Link_link__j3yA7","bodyLink":"Link_bodyLink__GKPBy","headerLink":"Link_headerLink__i2zBr"};